import { Component, EventEmitter, Output, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BaseComponent } from 'src/app/core/shared/common/base.component';

@Component({
  standalone: true,
  selector: 'app-compliance-tab-launcher',
  templateUrl: './compliance-tab-launcher.component.html',
  styleUrls: ['./compliance-tab-launcher.component.scss'],
  imports: [CommonModule],
})
export class ComplianceTabLauncherComponent extends BaseComponent {
  @Output() openPopup = new EventEmitter<void>();

  public isHovered = signal<boolean>(false);

  public handleClick(): void {
    this.openPopup.emit();
  }

  public onMouseEnter(): void {
    this.isHovered.set(true);
  }

  public onMouseLeave(): void {
    this.isHovered.set(false);
  }
}
